import { ModelBase } from './model';

class ScheduledReport extends ModelBase {
  static namespace = 'scheduled_report';

  static path = '/api/v2/reports/schedules';

  static async create(name, data) {
    const response = await super.objects().create(data, name);
    return response;
  }
}
export default ScheduledReport.register();
